import { canvasRGB } from 'stackblur-canvas';

/** 纯色填充的色值 */
export const CropperFillColor = '#333333';
/** 高斯模糊半径 */
const BlurRadius = 150;

/** 生成模糊背景的入参定义 */
interface GenerateBlurCanvasParam {
  img: HTMLImageElement | HTMLCanvasElement;
  requiredWidth: number;
  requiredHeight: number;
  position: {
    startX: number;
    startY: number;
    targetWidth: number;
    targetHeight: number;
  };
}

/** 生成模糊底图 */
export function generateBlurCanvas(config: GenerateBlurCanvasParam) {
  const { img, requiredWidth, requiredHeight, position } = config;
  const { startX, startY, targetWidth, targetHeight } = position;

  const canvas = document.createElement('canvas');
  canvas.width = requiredWidth;
  canvas.height = requiredHeight;

  const canvasCtx = canvas.getContext('2d') as CanvasRenderingContext2D;
  canvasCtx && canvasCtx.drawImage(img, startX, startY, targetWidth, targetHeight, 0, 0, requiredWidth, requiredHeight);
  canvasRGB(canvas, 0, 0, requiredWidth, requiredHeight, BlurRadius);

  return canvas;
}

/** 生成黑色底图 */
export function generateBlackCanvas(config: { requiredWidth: number; requiredHeight: number }) {
  const { requiredWidth, requiredHeight } = config;

  const canvas = document.createElement('canvas');
  canvas.width = requiredWidth;
  canvas.height = requiredHeight;

  const canvasCtx = canvas.getContext('2d');
  if (canvasCtx) {
    canvasCtx.fillStyle = CropperFillColor;
    canvasCtx.beginPath();
    canvasCtx.rect(0, 0, requiredWidth, requiredHeight);
    canvasCtx.fill();
  }

  return canvas;
}

/** 在一个 canvas 中绘制另一个canvas */
export function fillCanvasByCanvas(canvas: HTMLCanvasElement, targetCanvas: HTMLCanvasElement) {
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  ctx.drawImage(targetCanvas, 0, 0, targetCanvas.width, targetCanvas.height, 0, 0, canvas.width, canvas.height);

  return canvas;
}

/**
 * 通过本地加载的方式获取图片实例
 * @param {string} src 图片地址
 * @returns {Image} 图片实例
 */
export function getImageBasicInfo(src: string): Promise<HTMLImageElement | undefined> {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(undefined);
    img.src = src;
  });
}

/** 将一个 canvas 展示到元素中 */
export function showCanvas(canvas: HTMLCanvasElement, div?: HTMLElement) {
  const imageEl = document.createElement('img');
  imageEl.src = canvas.toDataURL();
  imageEl.style.maxWidth = '160px';
  imageEl.style.maxHeight = '130px';
  if (div) {
    div.innerHTML = '';
    div.append(imageEl);
  }
}
